<script setup lang="ts">
import { Icon } from '@iconify/vue'
import type { HTMLAttributes } from 'vue'
import { computed } from 'vue'
import { icons } from '@/notebook/components/icons'
import { cn } from '@/notebook/utils'

const props = defineProps<{
  name: keyof typeof icons
  class?: HTMLAttributes['class']
}>()

const icon = computed(() => icons[props.name])

if (!icon.value) {
  console.error(`Icon ${props.name} not found`)
}
</script>

<template>
  <Icon :icon="icon" :class="cn('w-4 h-4', props.class)" />
</template>
